/** Labels shown on /parent-form-config studio timezone settings. Keep in sync with BE STUDIO_SETTINGS_TIMEZONE_LABELS. */
export const STUDIO_SETTINGS_TIMEZONE_LABELS: Record<string, string> = {
  UTC: 'UTC',
  'America/New_York': 'Eastern Time (ET)',
  'America/Chicago': 'Central Time (CT)',
  'America/Denver': 'Mountain Time (MT)',
  'America/Phoenix': 'Arizona Time (MST)',
  'America/Los_Angeles': 'Pacific Time (PT)',
  'America/Anchorage': 'Alaska Time (AKT)',
  'Pacific/Honolulu': 'Hawaii Time (HT)',
  'America/Toronto': 'Eastern Time - Toronto',
  'America/Winnipeg': 'Central Time - Winnipeg',
  'America/Edmonton': 'Mountain Time - Edmonton',
  'America/Vancouver': 'Pacific Time - Vancouver',
  'Europe/London': 'London (GMT/BST)',
  'Europe/Paris': 'Central European Time (CET)',
  'Asia/Tokyo': 'Tokyo (JST)',
  'Asia/Shanghai': 'Shanghai (CST)',
  'Asia/Dubai': 'Dubai (GST)',
  'Australia/Perth': 'Perth (AWST)',
  'Australia/Darwin': 'Darwin (ACST)',
  'Australia/Adelaide': 'Adelaide (ACST/ACDT)',
  'Australia/Brisbane': 'Brisbane (AEST)',
  'Australia/Sydney': 'Sydney (AEST/AEDT)',
  'Australia/Melbourne': 'Melbourne (AEST/AEDT)',
  'Australia/Hobart': 'Hobart (AEST/AEDT)',
};

export const STUDIO_SETTINGS_TIMEZONE_OPTIONS: Array<{
  value: string;
  label: string;
}> = Object.entries(STUDIO_SETTINGS_TIMEZONE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

/** Include the current studio timezone if GHL synced a zone not in the curated list. */
export function getStudioTimezoneSelectOptions(currentTimezone: string) {
  const trimmed = currentTimezone?.trim() || 'UTC';
  if (STUDIO_SETTINGS_TIMEZONE_LABELS[trimmed]) {
    return STUDIO_SETTINGS_TIMEZONE_OPTIONS;
  }

  return [
    { value: trimmed, label: trimmed },
    ...STUDIO_SETTINGS_TIMEZONE_OPTIONS,
  ];
}
